export const DEFAULT_TRANSITION_DURATION = 500;
